module.exports = __webpack_public_path__ + "img/basics8.f7dc17a3.png";